export var VERTICAL_PRODUCT_TILE_CATEGORY_PATH_IDS = [
    "accessories|baby_accessories_2",
    "accessories|kids_accessories_2",
    "accessories|mens_accessories_2",
    "accessories|womens_accessories_2",
    "accessories|womens_accessories_2|bags_backpacks_2",
    "accessories|womens_accessories_2|clutches_purses_2",
    "accessories|womens_accessories_2|tech_accessories_2",
    "accessories|womens_accessories_2|travel_2",
    "accessories|womens_accessories_2|wallets_2",
    "apparel",
    "apparel|baby_apparel_2",
    "apparel|baby_apparel_2|bodysuits_footies_2",
    "apparel|baby_apparel_2|bottoms_2",
    "apparel|baby_apparel_2|dresses_rompers_2",
    "apparel|baby_apparel_2|sweaters_outerwear_2",
    "apparel|baby_apparel_2|swim_2",
    "apparel|baby_apparel_2|tops_2",
    "apparel|kids_apparel_2",
    "apparel|kids_apparel_2|bottoms_2",
    "apparel|kids_apparel_2|dresses_rompers_2",
    "apparel|kids_apparel_2|dresses_rompers_2_2",
    "apparel|kids_apparel_2|pajamas_robes_2",
    "apparel|kids_apparel_2|sweaters_outerwear_2",
    "apparel|kids_apparel_2|sweaters_outerwear_2_2",
    "apparel|kids_apparel_2|swim_2",
    "apparel|kids_apparel_2|tops_2",
    "apparel|mens_apparel",
    "apparel|mens_apparel_2",
    "apparel|mens_apparel_2|activewear_2",
    "apparel|mens_apparel_2|costumes_uniforms",
    "apparel|mens_apparel_2|jeans",
    "apparel|mens_apparel_2|outerwear",
    "apparel|mens_apparel_2|pants",
    "apparel|mens_apparel_2|printed_tees_2",
    "apparel|mens_apparel_2|shirts_polos_2",
    "apparel|mens_apparel_2|shorts",
    "apparel|mens_apparel_2|sleepwear",
    "apparel|mens_apparel_2|sleepwear_2",
    "apparel|mens_apparel_2|sleepwear_2_2",
    "apparel|mens_apparel_2|suits_tuxedos",
    "apparel|mens_apparel_2|sweaters_2",
    "apparel|mens_apparel_2|sweatshirts_hoodies",
    "apparel|mens_apparel_2|swimwear",
    "apparel|mens_apparel_2|tshirts_tank_tops",
    "apparel|mens_apparel|activewear",
    "apparel|mens_apparel|jeans",
    "apparel|mens_apparel|outerwear",
    "apparel|mens_apparel|pants",
    "apparel|mens_apparel|shirts_polos",
    "apparel|mens_apparel|shorts",
    "apparel|mens_apparel|sleepwear",
    "apparel|mens_apparel|suits_tuxedos",
    "apparel|mens_apparel|sweaters",
    "apparel|mens_apparel|sweatshirts_hoodies",
    "apparel|mens_apparel|swimwear",
    "apparel|womens_apparel",
    "apparel|womens_apparel_2",
    "apparel|womens_apparel_2|activewear",
    "apparel|womens_apparel_2|costumes_uniforms",
    "apparel|womens_apparel_2|dresses",
    "apparel|womens_apparel_2|intimates_shapewear",
    "apparel|womens_apparel_2|jeans",
    "apparel|womens_apparel_2|jumpsuits_rompers",
    "apparel|womens_apparel_2|kimonos_kaftans",
    "apparel|womens_apparel_2|knitwear_sweaters",
    "apparel|womens_apparel_2|loungewear",
    "apparel|womens_apparel_2|matching_sets",
    "apparel|womens_apparel_2|maternity",
    "apparel|womens_apparel_2|outerwear",
    "apparel|womens_apparel_2|pants_leggings",
    "apparel|womens_apparel_2|screen_printed_tshirts",
    "apparel|womens_apparel_2|shirts_blouses",
    "apparel|womens_apparel_2|shorts",
    "apparel|womens_apparel_2|skirts",
    "apparel|womens_apparel_2|sleepwear_nightwear",
    "apparel|womens_apparel_2|socks_hosiery",
    "apparel|womens_apparel_2|suits_blazers",
    "apparel|womens_apparel_2|sweatshirts_hoodies",
    "apparel|womens_apparel_2|swimwear_beachwear",
    "apparel|womens_apparel_2|tshirts_tank_tops",
    "apparel|womens_apparel|activewear",
    "apparel|womens_apparel|dresses",
    "apparel|womens_apparel|intimates_shapewear",
    "apparel|womens_apparel|jeans",
    "apparel|womens_apparel|jumpsuits_rompers",
    "apparel|womens_apparel|kimonos_kaftans",
    "apparel|womens_apparel|maternity",
    "apparel|womens_apparel|outerwear",
    "apparel|womens_apparel|pajamas_loungewear",
    "apparel|womens_apparel|pants",
    "apparel|womens_apparel|printed_tees",
    "apparel|womens_apparel|shirts_blouses",
    "apparel|womens_apparel|shorts",
    "apparel|womens_apparel|skirts",
    "apparel|womens_apparel|suits_blazers",
    "apparel|womens_apparel|sweaters",
    "apparel|womens_apparel|sweatshirts_hoodies",
    "apparel|womens_apparel|swimwear_cover_ups",
    "food_drink|beverages|drink_kits",
    "food_drink|beverages|non_alcoholic",
    "food_drink|coffee_tea|ice_tea_coffee",
    "footwear|mens_footwear_2",
    "footwear|womens_footwear_2",
    "kids_baby|baby_accessories_2",
    "kids_baby|infant_baby_2|bodysuits_footies_2",
    "kids_baby|infant_baby_2|sweaters_outerwear_2",
    "kids_baby|kids_2|bottoms_2",
    "kids_baby|kids_2|pajamas_robes_2",
    "kids_baby|kids_2|sweaters_outerwear_2",
    "kids_baby|kids_2|tops_2",
    "kids_baby|kids_accessories_2",
    "men|accessories_2",
    "men|apparel",
    "men|apparel_2",
    "men|apparel_2|activewear_2",
    "men|apparel_2|costumes_uniforms",
    "men|apparel_2|jeans",
    "men|apparel_2|loungewear",
    "men|apparel_2|matching_sets",
    "men|apparel_2|outerwear",
    "men|apparel_2|pants",
    "men|apparel_2|printed_tees_2",
    "men|apparel_2|shirts_polos_2",
    "men|apparel_2|shorts",
    "men|apparel_2|sleepwear",
    "men|apparel_2|suits_tuxedos",
    "men|apparel_2|sweaters_2",
    "men|apparel_2|sweatshirts_hoodies",
    "men|apparel_2|swimwear",
    "men|apparel_2|tshirts_tank_tops",
    "men|apparel|activewear",
    "men|apparel|blazers_sport_coats",
    "men|apparel|jeans",
    "men|apparel|outerwear",
    "men|apparel|pants",
    "men|apparel|shirts_polos",
    "men|apparel|shorts",
    "men|apparel|sleepwear",
    "men|apparel|suits_tuxedos",
    "men|apparel|sweaters",
    "men|apparel|sweatshirts_hoodies",
    "men|apparel|swimwear",
    "men|footwear_2",
    "men|footwear_2|sandals_2",
    "men|footwear_2|sneakers_athletic_shoes_2",
    "women|accessories_2",
    "women|apparel",
    "women|apparel_2",
    "women|apparel_2|activewear",
    "women|apparel_2|costumes_uniforms",
    "women|apparel_2|dresses",
    "women|apparel_2|intimates_shapewear",
    "women|apparel_2|jeans",
    "women|apparel_2|jumpsuits_rompers",
    "women|apparel_2|kimonos_kaftans",
    "women|apparel_2|knitwear_sweaters",
    "women|apparel_2|loungewear",
    "women|apparel_2|matching_sets",
    "women|apparel_2|maternity",
    "women|apparel_2|outerwear",
    "women|apparel_2|pants_leggings",
    "women|apparel_2|screen_printed_tshirts",
    "women|apparel_2|shirts_blouses",
    "women|apparel_2|shorts",
    "women|apparel_2|skirts",
    "women|apparel_2|sleepwear_nightwear",
    "women|apparel_2|socks_hosiery",
    "women|apparel_2|suits_blazers",
    "women|apparel_2|sweatshirts_hoodies",
    "women|apparel_2|swimwear_beachwear",
    "women|apparel_2|tshirts_tank_tops",
    "women|apparel|activewear",
    "women|apparel|dresses",
    "women|apparel|intimates_shapewear",
    "women|apparel|jeans",
    "women|apparel|jumpsuits_rompers",
    "women|apparel|kimonos",
    "women|apparel|maternity",
    "women|apparel|outerwear",
    "women|apparel|pants",
    "women|apparel|printed_tees",
    "women|apparel|shorts",
    "women|apparel|skirts",
    "women|apparel|sleepwear",
    "women|apparel|suits_blazers",
    "women|apparel|sweaters",
    "women|apparel|sweatshirts_hoodies",
    "women|apparel|swimwear",
    "women|apparel|tops",
    "women|footwear_2"
];
